// L’onglet « Aujourd’hui » de la fiche d’une personnalité (15 octobre 2026).
// Jamais de genre deviné (« Où l’on en parle ») ; jamais un nombre de mentions :
// le volume se dit rapporté à son habitude, la part de voix en %.
export default {
  aucune: 'Aucune écoute rendue pour l’instant : cet onglet se remplit après la prochaine écoute.',
  quand: { aujourdhui: 'aujourd’hui', hier: 'hier' },
  chiffres: {
    aria: 'Les chiffres du jour',
    note: {
      titre: 'Sa note',
      unite: 'sur 100',
      ecart: '{n} sur 7 jours',
      sansRecul: 'moins d’une semaine d’écoute',
    },
    volume: {
      titre: 'Ce qu’on en parle',
      valeur: '×{v}',
      unite: 'son habitude',
      vide: 'pas encore d’habitude',
      attente: 'quelques jours d’écoute encore',
      record: 'le plus haut des 30 derniers jours',
      dessus: 'au-dessus de son habitude',
      dessous: 'en dessous de son habitude',
      habituel: 'dans son habitude',
    },
    part: {
      titre: 'Part de voix',
      unite: '% de vos suivis',
      vide: 'pas mesurée ce jour-là',
      ecart: '{n} points depuis la veille',
      stable: 'comme la veille',
      sansVeille: 'rien à comparer la veille',
    },
    publications: {
      titre: 'Ses publications',
      unite: '% de réactions',
      uniteMultiple: 'ses réactions habituelles',
      vide: 'aucune publication',
      ceJour: 'ce jour-là',
      nombre: 'publication | publication | publications',
      sansHabitude: 'pas encore d’habitude pour comparer',
      dessus: 'au-dessus de son habitude',
      dessous: 'en dessous de son habitude',
      habituel: 'dans son habitude',
    },
  },
  journee: {
    titre: 'Ce qui a fait sa journée',
    jour: 'Journée du {jour}',
    sansResume: 'Pas de résumé pour ce jour-là.',
    peuDeMatiere: 'peu de matière ce jour-là',
    sens: '({sens})',
  },
  courbe: {
    titre: 'Sa note et ce qu’on en parle, sur 30 jours',
    note: 'la note',
    volume: 'le volume, rapporté à son habitude',
    neutre: 'la ligne pointillée : 50, neutre',
    aujourdhui: 'aujourd’hui',
    aria: 'Sa note sur 30 jours : {debut} au premier jour, {fin} au dernier',
  },
  citations: {
    titre: 'Les citations du jour',
    toutes: 'Toutes les citations',
    aucune: 'Aucune citation relevée ces derniers jours.',
  },
  alertes: {
    titre: 'Les alertes du jour',
    nouvelle: 'Nouvelle',
    aucune: 'Aucune alerte ces deux derniers jours.',
    personas: 'Voir ceux qui en parlent',
    positions: 'Voir les positions',
  },
  plateformes: {
    titre: 'Où l’on en parle',
    aucune: 'Rien de relevé ce jour-là.',
    pct: '{n} %',
    moinsDeUn: '< 1 %',
  },
  publications: {
    titre: 'Ses publications',
    aucune: 'Aucune publication ce jour-là.',
    sansHabitude: '{n} publication ce jour-là ; pas encore assez de recul pour la comparer à son habitude. | {n} publication ce jour-là ; pas encore assez de recul pour la comparer à son habitude. | {n} publications ce jour-là ; pas encore assez de recul pour les comparer à son habitude.',
    dessus: '{n} publication ce jour-là, avec {r} % de réactions de plus que son habitude. | {n} publication ce jour-là, avec {r} % de réactions de plus que son habitude. | {n} publications ce jour-là, avec {r} % de réactions de plus que son habitude.',
    dessous: '{n} publication ce jour-là, avec {r} % de réactions de moins que son habitude. | {n} publication ce jour-là, avec {r} % de réactions de moins que son habitude. | {n} publications ce jour-là, avec {r} % de réactions de moins que son habitude.',
    multiple: '{n} publication ce jour-là, avec {x} fois ses réactions habituelles. | {n} publication ce jour-là, avec {x} fois ses réactions habituelles. | {n} publications ce jour-là, avec {x} fois ses réactions habituelles.',
    habituel: '{n} publication ce jour-là, dans la moyenne de ses réactions habituelles. | {n} publication ce jour-là, dans la moyenne de ses réactions habituelles. | {n} publications ce jour-là, dans la moyenne de ses réactions habituelles.',
  },
  // Le baromètre du sentiment (16 octobre 2026).
  barometre: {
    titre: 'Baromètre du sentiment',
    lisse: 'ce qui se dit, lissé sur trois jours',
    sens: { favorable: 'Favorables', neutre: 'Neutres', defavorable: 'Défavorables' },
    pct: '{n} %',
    points: '{n} pts en 7 jours',
    stable: 'stable en 7 jours',
    solde: 'Solde : {n} (les favorables moins les défavorables)',
    barreAria: '{f} % favorables, {n} % neutres, {d} % défavorables',
    colonne: '{jour} : {f} % favorables, {n} % neutres, {d} % défavorables',
    colonneVide: '{jour} : rien lu ce jour-là',
    vide: 'case vide : un jour sans matière',
  },
}
